import getStore from '../store/store';
import filterOptions from '../utils/filterOptions';
export default (function () { return filterOptions(getStore().query); });
//# sourceMappingURL=getSearchResults.js.map